import { FluidTemperature } from "requests";

export const generateFluidAndTemperatureData = (
  fluidTemperatures: FluidTemperature[],
  temperatureUnitSymbol: string,
  fluidType?: string | null
) => {
  if (fluidTemperatures?.length > 0) {
    return fluidTemperatures.reduce(
      (acc: any, el) => {
        return acc.map((accEl: any) => {
          if (accEl.name === "Fluid Rate (mLs/hr)") {
            accEl.val = [
              ...accEl.val,
              {
                fluidTemperatureId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.fluidRate
              }
            ];
          }
          if (accEl.name.endsWith("Volume Infused")) {
            accEl.val = [
              ...accEl.val,
              {
                fluidTemperatureId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.volumeInfused
              }
            ];
          }
          if (accEl.name.startsWith("Temperature")) {
            accEl.val = [
              ...accEl.val,
              {
                fluidTemperatureId: el._id || el.fakeId,
                timeMonitoring: el.timeMonitoring,
                value: el.temperature
              }
            ];
          }
          return accEl;
        });
      },
      [
        {
          name: "Fluid Rate (mLs/hr)",
          _id: 0,
          val: []
        },
        {
          name: fluidType ? `${fluidType} Volume Infused` : "Volume Infused",
          _id: 1,
          val: []
        },
        {
          name: `Temperature (${temperatureUnitSymbol})`,
          _id: 2,
          val: []
        }
      ]
    );
  }

  return [];
};
